import { BrowserRouter } from "react-router-dom"

import { AllProviders } from "./providers"
import { AppRoutes } from "./Routes"

function App() {
	return (
		<BrowserRouter>
			<AllProviders>
				<AppRoutes />
			</AllProviders>
		</BrowserRouter>
	)
}

export default App
